export default class LaptopSetupEvent {
    constructor(type) {
        this.type = type;
    }
}

LaptopSetupEvent.PERFORM = 'LaptopSetupEvent.PERFORM';